import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import * as Permissions from 'permissions';
import * as Actions from 'actions';

class MapListItem extends React.Component {
  static propTypes = {
    map: PropTypes.object,
    onViewMap: PropTypes.func,
    onClick: PropTypes.func,
  }
  render() {
    const { map, favorites } = this.props;
    if(!map || !map.properties) {
      return <noscript />
    }

    const is_favorite = favorites.find((favorite) => typeof favorite === 'string' ? favorite == map._id : favorite._id == map._id) ? true: false;

    const link = this.props.hasPermission(Permissions.VIEW_CLIENTS) ? `clients/map/${map._id}` : `map/search/${map._id}`;
    const { properties } = map;
    return <li onClick={this.props.onClick ? this.props.onClick : f => f} className={`map-list-item level-${properties.star_level} clearfix`}>
      <h6><i className="fa fa-map"></i> {properties.title}</h6>
      <p>{moment(properties.storm_date.slice(0,10)).format('MMM DD, YYYY')} - {properties.star_level} Star - {properties.max_hail_size}" Hail </p>
      <div className="pull-right btn-group">
        <div onClick={e => this.props.favoriteMap(map._id)} className={`btn btn-${is_favorite? 'primary':'info'}`}><i className={`fa fa-${is_favorite ? 'star':'star-o'}`}></i> {is_favorite ? '' : 'Favorite'}</div>
        <Link to={link} onClick={e => {
          if(this.props.onViewMap) {
            this.props.onViewMap(map);
          }
        }} className="btn"><i className="fa fa-eye"></i> View</Link>
      </div>
    </li>
  }
}

export default connect(({connection}) => ({favorites: connection.user? connection.user.favorites : []}), Actions)(MapListItem);



// WEBPACK FOOTER //
// ./src/browser/components/maps/map-list-item.js